'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageChannelFiltersService
 * @description manages the list of available characteristics on which channels can be filtered
 */

angular.module('v-tv-package-services').service('TvPackageChannelFiltersService', function TvPackageChannelFiltersService(TvPackageApi, tvPackageConfig) {

  /**
   * @ngdoc method
   * @name vTvPackageServices.TvPackageChannelFiltersService#getFilters
   * @methodOf vTvPackageServices.TvPackageChannelFiltersService
   * @description calls the api to get the available characteristics
   * @returns {Promise} A promise that completes after the call to the characteristics endpoint is completed
   */
  this.getFilters = function () {
    return TvPackageApi.doGet(tvPackageConfig.ENDPOINT.CHARACTERISTICS).then(function (response) {
      return response.data;
    });
  };
});